// extracted by mini-css-extract-plugin
module.exports = {"bubble":"Bubble_bubble__1Gsg3","yellow":"Bubble_yellow__WTd6C","blue":"Bubble_blue__3U5n0","top-right":"Bubble_top-right__3TGFn"};